import React, { Component } from "react";
import { Modal, Image, Button } from "react-bootstrap";
import { capitalize, get, isString } from "lodash";
import { PATHS } from "../../constant";
import { Link } from "react-router-dom";
import {
  getColor,
  dateFormat,
  replaceCharacterWith,
  isValidArray,
  formatNumber,
  getBackgroundColorCode,
  projectFormLabel
} from "../../helper";
import { AILoader } from "../../component/Loader";
import {
  getAIprojectSummary,
  getAIsimilarProjects,
  getProjectActionItem,
  getProjectRecommendation,
  getProjectRecommendationQuestions
} from "../../services/apiServices";
import {
  OrganizationTemplate,
  RedirectUser,
  ReadMore
} from "../reusableComponent";
import request from "../../services/requestService";
import StarIcon from "../../assets/start_Icon.svg";
import AI_smmary_GreyIcon from "../../assets/AI_smmary_GreyIcon.svg";
import AI_Summary_White_icon from "../../assets/AI_Summary_White icon.svg";
import Similar_Issue_grey_icon from "../../assets/Similar-Issue-grey-icon.svg";
import similar_issue_white_icon from "../../assets/similar-issue-white-icon.svg";
import star_yellow from "../../assets/star_icon.svg";
import AI_Similarity_heading from "../../assets/project_ai_similarities.svg";
import { PmFoundationStone } from "../pmFoundationStone/pmFoundationStone";
import { CmPragatiYatra } from "../cmPragatiYatra/cmPragatiYatra";
import { CmFoundationStone } from "../cmFoundationStone/cmFoundationStone";
import { PmgsHipimage } from "../pmgsHipp/pmgsHip";
import { PmGatiShakti } from "../pmGatiShakti/pmGatiShakti";
import { March24 } from "../march24";
import { Pragati } from "../prgatiReview";
import { Nip } from "../nipReview";
import { Pli } from "../pliReview";
import long_description_icon from "../../assets/long_description_icon.svg";
import ai_disclaimer from "../../assets/ai_disclaimer.svg";
import IndiaAI_Logo from "../../assets/IndiaAI_Logo.png";
import IconTime from "../../assets/icon-time.svg";
import { iigBaseUrl } from "../../globalConfig";
import { IIG_PATHS } from "../../constant";
import xss from "xss";
import AISimilaritiesAnalysis from "./AISimilaritiesAnalysis";
import LoaderTemplate from "../../component/LoaderTemplate";
import { ListingLoaderTemplate } from "../../component/LoadersTemplate";
import action from "../../assets/tick_ic.png";
import rationale from "../../assets/rationale.png";
import auth from "../../assets/auth.png";
import prior from "../../assets/prior.png";
import Separator_AI from "../../assets/Separator_AI.svg";
import AI_Question_Icon from "../../assets/AI_Question_Icon.svg";
import issue_update_icon1 from "../../assets/issue_update_icon1.svg";
import issue_update_icon2 from "../../assets/issue_update_icon2.svg";
import issue_update_icon3 from "../../assets/issue_update_icon3.svg";
import issue_update_icon4 from "../../assets/issue_update_icon4.svg";
import Issue_Update_Grey_Icon from "../../assets/Issue_Update_Grey_Icon.svg";
import Issue_Update_white_Icon from "../../assets/Issue_Update_white_Icon.svg";
import Recom_action_grey from "../../assets/Recom_action_grey.svg";
import Recom_Action_white_icon from "../../assets/Recom_Action_white_icon.svg";
export class AIprojectsummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      isLoading: false,
      activeTab: "AI Summary",
      isLoaderActive: true,
      long_summary: "",
      overallProjectsData: [],
      showOtherPPList: false,
      locationsProjectsData: [],
      geographyProjectsData: [],
      selectedRadio: "OVERALL",
      similarityLoader: false,
      meetingDirections: [],
      projectRecommendation: [],
      projectRecommendationQuestions: []
    };
    this.flagTimer = null;
  }
  toggleOtherPPList = () => {
    this.setState({
      showOtherPPList: !this.state.showOtherPPList
    });
  };
  componentDidMount = async () => {
    const { projectData } = this.props;

    this.setState({ isLoaderActive: true });

    const projectId = get(projectData, "id");

    const payload = {
      project_id: projectId
    };

    try {
      const [projectsSummaryRes, similarProjectsRes] = await Promise.all([
        request(getAIprojectSummary(payload)),
        request(getAIsimilarProjects(payload))
      ]);

      const [
        projectActionItemRes,
        projectRecommendationRes,
        projectRecommendationQuestionsRes
      ] = await Promise.all([
        request(getProjectActionItem(payload)),
        request(getProjectRecommendation(projectId)),
        request(getProjectRecommendationQuestions(projectId))
      ]);

      const overallProjectsData = get(
        similarProjectsRes,
        "data.data.default",
        []
      );

      const locationsProjectsData = get(
        similarProjectsRes,
        "data.data.location",
        []
      );

      const geographyProjectsData = get(
        similarProjectsRes,
        "data.data.issue",
        []
      );

      this.setState({
        long_summary: get(projectsSummaryRes, "data.data.summary", ""),
        overallProjectsData,
        locationsProjectsData,
        geographyProjectsData,

        selectedRadio: overallProjectsData.length > 0 ? "OVERALL" : "OVERALL",

        meetingDirections: get(projectActionItemRes, "data.data.updates"),
        projectRecommendation: get(projectRecommendationRes, "data.data"),
        projectRecommendationQuestions: get(
          projectRecommendationQuestionsRes,
          "data.data"
        )
      });
    } catch (error) {
      console.error("AI API error:", error);
    } finally {
      this.setState({ isLoaderActive: false });
    }
  };

  componentWillUnmount() {
    if (this.flagTimer) {
      clearTimeout(this.flagTimer);
    }
  }
  handleTabChange = tab => {
    this.setState({ activeTab: tab });
  };

  handlecheckbox = type => {
    this.setState({
      selectedRadio: type,
      similarityLoader: true
    });

    setTimeout(() => {
      this.setState({
        similarityLoader: false
      });
    }, 500);
  };
  onClose = () => {
    this.props.onClick(false);
  };
  formatDate = timestamp => {
    if (!timestamp) return "-";

    return new Date(timestamp).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    });
  };
  openProjectPageBasedOnCommonLink = (includeReadMore = false) => {
    const { projectData } = this.props;
    const iigProjectReferenceId = get(projectData, "iigProjectReferenceId");
    return (
      <>
        <a
          href={
            iigBaseUrl +
            IIG_PATHS.IIG_PROJECT_DETAIL +
            "?iigProject=" +
            iigProjectReferenceId
          }
          target="_blank"
        >
          {includeReadMore ? (
            <ReadMore
              content={get(projectData, "name", "NA")}
              clamp={2}
              displayExpandButtons={false}
            />
          ) : (
            <> #{get(projectData, "commonId")}</>
          )}
        </a>
      </>
    );
  };
  openProjectPageBasedOnLink = (includeReadMore = false) => {
    const { projectData } = this.props;
    const status = get(projectData, "status");
    const isIIGDraft = status === "CRIP_DRAFT";
    return (
      <>
        <a
          href={`${PATHS.PROJECT_DETAILS}?projectId=${get(projectData, "id")}`}
          target="_blank"
        >
          {includeReadMore ? (
            <ReadMore
              content={get(projectData, "name", "NA")}
              clamp={2}
              displayExpandButtons={false}
              lineHeightTitle={1.3}
            />
          ) : (
            <> #{get(projectData, "displayId", "NA")}</>
          )}
        </a>
      </>
    );
  };

  getPriorityClass = priority => {
    switch (priority.toLowerCase()) {
      case "high":
        return "priority high";
      case "medium":
        return "priority medium";
      case "low":
        return "priority low";
      default:
        return "priority";
    }
  };

  renderTabContent = () => {
    const {
      activeTab,
      long_summary,
      overallProjectsData,
      showOtherPPList,
      meetingDirections,
      projectRecommendation,
      projectRecommendationQuestions
    } = this.state;
    const { projectData } = this.props;
    const iigProjectCommonId = get(projectData, "commonId");
    const upProjectId = get(projectData, "upProjectId");
    const status =
      get(projectData, "status") &&
      replaceCharacterWith(
        get(projectData, "status", "NA"),
        "_",
        " "
      ).toLowerCase();
    switch (activeTab) {
      case "AI Summary":
        return (
          <>
            {long_summary == "" ? (
              <div className="nodataFound-container">
                <Image src="https://pmiic-local-files.s3.ap-south-1.amazonaws.com/no_data_found.png" />
                <h3 className={`no-data-found`}>No Data Found</h3>
              </div>
            ) : (
              <>
                <div class="issue-list-top" style={{ padding: 0 }}>
                  <div className="issue-list-header">
                    <span
                      className={`issue-number ${
                        get(projectData, "duplicate")
                          ? "duplicate-issue-number"
                          : ""
                      }`}
                      style={{ display: "flex" }}
                    >
                      {iigProjectCommonId && (
                        <div className="id-wrapper-box mr-2">
                          <p className="border-right mb-1 common-project-id">
                            COMMON PROJECT ID{" "}
                            <b className="link-color mr-2 iig-project-link-color">
                              {this.openProjectPageBasedOnCommonLink()}
                            </b>
                          </p>
                        </div>
                      )}
                      {upProjectId && (
                        <div className="id-wrapper-box mr-2">
                          <p className="border-right mb-1 common-project-id">
                            CMIS PROJECT ID{" "}
                            <b className="link-color mr-2 iig-project-link-color">
                              #{upProjectId}
                            </b>
                          </p>
                        </div>
                      )}
                      <div className="project-id mb-1">
                        PMG Project Id{" "}
                        <b data-test="project-id">
                          {this.openProjectPageBasedOnLink()}
                        </b>
                      </div>
                      {/* <b>
                        <a
                          href={`${PATHS.PROJECT_DETAILS}?projectId=${get(
                            projectData,
                            "id"
                          )}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          #{projectData.displayId}
                        </a>
                      </b> */}
                    </span>
                    <h2
                      className={`issue-title ${
                        /[\u0900-\u097F]/.test(get(projectData, "name"))
                          ? "hindi-text-wrap-comment"
                          : ""
                      }`}
                    >
                      {get(projectData, "name", null)}
                    </h2>
                  </div>
                  <Button
                    className={`btn-extra-small ${getColor(
                      status
                    )} unClickable`}
                    style={{
                      borderRadius: "20px",
                      marginRight: "0em",
                      fontSize: "12px",
                      fontFamily: "mpb",
                      textTransform: "uppercase",
                      padding: "6px 20px"
                    }}
                  >
                    {status}
                  </Button>
                </div>

                <div
                  className="description-card"
                  style={{ backgroundColor: "#fff" }}
                >
                  <h3>
                    <Image src={long_description_icon} />{" "}
                    <span className="ai-description-text">Summary</span>
                  </h3>
                  <div
                    style={{ whiteSpace: "pre-line" }}
                    dangerouslySetInnerHTML={{
                      __html: xss(long_summary)
                    }}
                  />
                  {/* <p style={{ whiteSpace: "pre-line" }}>{long_summary}</p> */}
                  {/* <div
                    style={{ whiteSpace: "pre-line" }}
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(long_summary)
                    }}
                  /> */}
                </div>
              </>
            )}
          </>
        );

      case "Similar Projects":
        const {
          selectedRadio,
          overallProjectsData,
          locationsProjectsData,
          geographyProjectsData,
          similarityLoader
        } = this.state;

        let projectsData = [];

        switch (selectedRadio) {
          case "LOCATION":
            projectsData = locationsProjectsData;
            break;

          case "GEOGRAPHY":
            projectsData = geographyProjectsData;
            break;

          default:
            projectsData = overallProjectsData;
        }
        return (
          <>
            <div className="aiprojects-data-radiobutton">
              <div
                className="d-flex align-items-center"
                onClick={() => this.handlecheckbox("OVERALL")}
                style={{ cursor: "pointer" }}
              >
                <input
                  type="radio"
                  name="overall"
                  value="OVERALL"
                  checked={selectedRadio === "OVERALL"}
                  readOnly
                />

                <div className="aiprojects-radio-buttontext ml-2">Overall</div>
              </div>
              <div
                className="d-flex align-items-center"
                onClick={() => this.handlecheckbox("GEOGRAPHY")}
                style={{ cursor: "pointer" }}
              >
                <input
                  type="radio"
                  name="geography"
                  value="GEOGRAPHY"
                  checked={selectedRadio === "GEOGRAPHY"}
                  readOnly
                />

                <div className="aiprojects-radio-buttontext ml-2">
                  By Issues
                </div>
              </div>
              <div
                className="d-flex align-items-center mr-4"
                onClick={() => this.handlecheckbox("LOCATION")}
                style={{ cursor: "pointer" }}
              >
                <input
                  type="radio"
                  name="location"
                  value="LOCATION"
                  checked={selectedRadio === "LOCATION"}
                  readOnly
                />

                <div className="aiprojects-radio-buttontext ml-2">
                  By Location
                </div>
              </div>
            </div>
            {projectsData.length == 0 ? (
              <div
                className="nodataFound-container"
                style={{ marginTop: "3em" }}
              >
                <Image src="https://pmiic-local-files.s3.ap-south-1.amazonaws.com/no_data_found.png" />
                <h3 className={`no-data-found`}>No Data Found</h3>
              </div>
            ) : (
              <>
                {" "}
                {projectsData.map((project, index) => {
                  const isLast = index === projectsData.length - 1;

                  const iigProjectCommonId = get(project, "commonId");
                  const upProjectId = get(project, "upProjectId");

                  const status =
                    isString(get(project, "status")) &&
                    get(project, "status")
                      .replace(/[_]/, " ")
                      .toLowerCase();

                  const isIIGDraft = status === "iig draft";

                  const isResolved =
                    get(project, "projectStatusWithRespectToIssueStatus") ===
                    "RESOLVED";

                  const projectResolutionDate = get(
                    project,
                    "projectResolutionDate"
                  )
                    ? dateFormat(get(project, "projectResolutionDate"))
                    : "NA";

                  const createdBy =
                    project.projectPPList && project.projectPPList.length
                      ? project.projectPPList[0]
                      : null;

                  const projectPPList =
                    project.projectPPList && project.projectPPList.length
                      ? project.projectPPList
                      : [];

                  const organistionArr =
                    projectPPList.filter(
                      item => item && item.organizationGroup
                    ) || [];
                  function openProjectPageBasedOnLink(includeReadMore = false) {
                    const status = get(project, "status");
                    const isIIGDraft = status === "CRIP_DRAFT";
                    return (
                      <>
                        <a
                          href={`${PATHS.PROJECT_DETAILS}?projectId=${get(
                            project,
                            "id"
                          )}`}
                          target="_blank"
                        >
                          {includeReadMore ? (
                            <ReadMore
                              content={get(project, "name", "NA")}
                              clamp={5}
                              displayExpandButtons={false}
                              lineHeightTitle={1.3}
                            />
                          ) : (
                            <> #{get(project, "displayId", "NA")}</>
                          )}
                        </a>
                      </>
                    );
                  }

                  function getUniqueOrganizations(data) {
                    const uniqueOrgs = new Set(
                      data.map(item => item.organizationGroup)
                    );
                    return Array.from(uniqueOrgs);
                  }

                  const uniqueOrganizations = getUniqueOrganizations(
                    organistionArr
                  );

                  const projectCost = formatNumber(
                    get(project, "revisedCost", 0) || get(project, "cost", "0")
                  );

                  let projectLocations = [];

                  if (isValidArray(get(project, "locations"))) {
                    if (get(project, "sponsoredByCategory") === "STATE") {
                      projectLocations = get(project, "locations")
                        .map(location => {
                          if (location.districtIdName.length > 0) {
                            return location.districtIdName
                              .map(district => district.name)
                              .join(", ");
                          }
                          return "-";
                        })
                        .join(", ");
                    } else {
                      projectLocations = get(project, "locations").map(
                        (location, i) =>
                          i < get(project, "locations").length - 1
                            ? location.state + ", "
                            : location.state
                      );
                    }
                  }

                  return (
                    <div
                      key={project.id}
                      style={{
                        marginBottom: isLast ? "5px" : "17px",
                        marginTop: index == 0 ? 35 : null
                      }}
                    >
                      {similarityLoader ? (
                        <LoaderTemplate
                          parentClass="loader-project-list"
                          times={10}
                          height={65}
                          children={<ListingLoaderTemplate />}
                        />
                      ) : (
                        <div
                          className="project-list-box-wrapper"
                          data-test="project-list-wrapper"
                        >
                          <div
                            className="project-list-box-top"
                            style={{ borderBottom: "1px solid transparent" }}
                          >
                            <div className="project-box-top-upper">
                              <div
                                className="project-name-section"
                                style={{ width: "100%" }}
                              >
                                <div className="d-flex flex-wrap">
                                  <div>
                                    {iigProjectCommonId && (
                                      <div className="id-wrapper-box mr-2">
                                        <p className="border-right mb-1 common-project-id">
                                          COMMON PROJECT ID{" "}
                                          <b className="link-color mr-2 iig-project-link-color">
                                            {iigProjectCommonId}
                                          </b>
                                        </p>
                                      </div>
                                    )}

                                    {upProjectId && (
                                      <div className="id-wrapper-box mr-2">
                                        <p className="border-right mb-1 common-project-id">
                                          CMIS PROJECT ID{" "}
                                          <b className="link-color mr-2 iig-project-link-color">
                                            #{upProjectId}
                                          </b>
                                        </p>
                                      </div>
                                    )}
                                  </div>

                                  <div className="project-id mb-1 issue-number ">
                                    PMG PROJECT ID{" "}
                                    <b data-test="project-id">
                                      {openProjectPageBasedOnLink()}
                                    </b>
                                  </div>

                                  {uniqueOrganizations.map(
                                    (organization, i) => (
                                      <OrganizationTemplate
                                        key={i}
                                        title={organization}
                                        classes="organisation mb-1 g"
                                      />
                                    )
                                  )}

                                  <div
                                    className="project-stage-section"
                                    style={{
                                      marginLeft: "auto",
                                      marginRight: "-1em"
                                    }}
                                  >
                                    <div
                                      className={`${getBackgroundColorCode(
                                        status
                                      )} project-stage-background`}
                                    >
                                      <span className="project-stage">
                                        {status}
                                      </span>
                                    </div>

                                    {isResolved ? (
                                      <div className="resolution-date">
                                        <div>Resolved on</div>
                                        <div className="second-row">
                                          <Image src={IconTime} alt="Time" />
                                          <span>{projectResolutionDate}</span>
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                </div>

                                <h2
                                  className="project-name"
                                  data-test="project name"
                                >
                                  {project.name}

                                  <AISimilaritiesAnalysis
                                    tooltipContent={
                                      <>
                                        <div className="ai-modal-header">
                                          <Image src={AI_Similarity_heading} />
                                        </div>

                                        {(() => {
                                          const analysis =
                                            project.reasoning || "";

                                          return (
                                            <div
                                              className="ai-points"
                                              style={{ marginBottom: 10 }}
                                            >
                                              {analysis.length > 0
                                                ? analysis
                                                : "N/A"}
                                            </div>
                                          );
                                        })()}
                                      </>
                                    }
                                  >
                                    <Image
                                      src={star_yellow}
                                      className="sparkle_image"
                                    />
                                  </AISimilaritiesAnalysis>
                                </h2>
                                <div
                                  className="project-status"
                                  style={{
                                    color: "#525252",
                                    marginTop: "0px",
                                    marginBottom: "-5px",
                                    fontFamily: "mpsb"
                                  }}
                                >
                                  {project.projectCompletionDTO.status}
                                </div>
                              </div>
                            </div>

                            <div className="project-box-top-lower">
                              <div className="project-details-left-section">
                                <div className="project-detail-unit">
                                  <div className="heading-title">
                                    Sponsoring Ministry -
                                  </div>
                                  <span
                                    className="heading-text"
                                    style={{ paddingLeft: "5px" }}
                                  >
                                    {get(project, "sponsoredBy")}
                                  </span>
                                </div>
                                {get(project, "sponsoringDepartment") ? (
                                  <div className="project-detail-unit">
                                    <div className="heading-title">
                                      {projectFormLabel(
                                        get(project, "sponsoredByid"),
                                        "department",
                                        "Sponsoring Department"
                                      )}{" "}
                                      - &nbsp;
                                    </div>
                                    <span className="heading-text">
                                      {get(
                                        project,
                                        "sponsoringDepartment.name"
                                      )}
                                    </span>
                                  </div>
                                ) : null}
                                {isValidArray(get(project, "locations")) ? (
                                  <div className="project-detail-unit">
                                    <div
                                      className="heading-text"
                                      style={{ minWidth: "fit-content" }}
                                    >
                                      Project Location(s) -
                                    </div>
                                    <ReadMore
                                      content={
                                        <span
                                          className="heading-text"
                                          style={{
                                            color: "black",
                                            paddingLeft: "5px"
                                          }}
                                        >
                                          {""}
                                          {projectLocations}
                                        </span>
                                      }
                                      clamp={3}
                                      displayExpandButtons={false}
                                    />
                                  </div>
                                ) : null}
                                <div className="project-issues-summary">
                                  <div className="project-issue-open">
                                    <span
                                      className="heading-title"
                                      style={{
                                        fontSize: 13,
                                        fontFamily: "mpb"
                                      }}
                                    >
                                      Issue(s) Open -
                                    </span>
                                    <span className="project-issue-count">
                                      {get(project, "openIssuesCount", 0)}
                                    </span>
                                  </div>

                                  <span className="project-issue-divider">
                                    |
                                  </span>

                                  <div className="project-issue-resolved">
                                    <span
                                      className="heading-title"
                                      style={{
                                        fontSize: 13,
                                        fontFamily: "mpb"
                                      }}
                                    >
                                      Issue(s) Resolved -
                                    </span>
                                    <span className="project-issue-count">
                                      {get(project, "resolvedIssuesCount", 0)}
                                    </span>
                                  </div>
                                </div>

                                {get(project, "projectCompletionDTO") &&
                                get(
                                  project,
                                  "projectCompletionDTO.percentage"
                                ) ? (
                                  <div className="physical-progress-wrapper">
                                    <div
                                      className="progress-upper d-flex align-items-center fw-bold"
                                      style={{ marginTop: 1 }}
                                    >
                                      Physical Progress -{" "}
                                      <span className="d-inline-block">
                                        {get(
                                          project,
                                          "projectCompletionDTO.percentage"
                                        )}
                                        %
                                      </span>
                                    </div>
                                    {get(
                                      project,
                                      "projectCompletionDTO.physicalProgressAsOf"
                                    ) ? (
                                      <div className="progress-lower">
                                        (as of{" "}
                                        {dateFormat(
                                          get(
                                            project,
                                            "projectCompletionDTO.physicalProgressAsOf"
                                          )
                                        )}
                                        )
                                      </div>
                                    ) : get(
                                        project,
                                        "projectCompletionDTO.date"
                                      ) ? (
                                      <div className="progress-lower">
                                        (as of{" "}
                                        {dateFormat(
                                          get(
                                            project,
                                            "projectCompletionDTO.date"
                                          )
                                        )}
                                        )
                                      </div>
                                    ) : null}
                                  </div>
                                ) : null}
                                <div
                                  className="d-flex tags-contatiner"
                                  style={{ marginLeft: "-18px" }}
                                >
                                  <Pragati
                                    className={"pragati-review-project-detail"}
                                    isValidProject={get(
                                      project,
                                      "pragatiReview"
                                    )}
                                  />
                                  <Nip
                                    className={"pragati-review-project-detail"}
                                    isValidProject={get(project, "nipReview")}
                                  />
                                  <PmFoundationStone
                                    className={"pragati-review-project-detail"}
                                    isValidProject={get(
                                      project,
                                      "pmFoundationStone"
                                    )}
                                  />
                                  <CmPragatiYatra
                                    className={"pragati-review-project-detail"}
                                    isValidProject={get(
                                      project,
                                      "cmPragatiYatra"
                                    )}
                                  />
                                  <CmFoundationStone
                                    className={"pragati-review-project-detail"}
                                    isValidProject={get(
                                      project,
                                      "cmFoundationStone"
                                    )}
                                  />
                                  <PmgsHipimage
                                    className={"pragati-review-project-detail"}
                                    isValidProject={get(project, "pmgsHip")}
                                  />
                                  <Pli
                                    className={"pragati-review-project-detail"}
                                    isValidProject={get(project, "pli")}
                                  />
                                  <March24
                                    className={"pragati-review-project-detail"}
                                    isValidProject={get(project, "march24")}
                                  />
                                  <PmGatiShakti
                                    className={"pragati-review-project-detail"}
                                    isValidProject={get(
                                      project,
                                      "pmGatiShaktiNew"
                                    )}
                                  />
                                </div>
                              </div>

                              <div className="project-details-right-section">
                                <div className="project-cost-section">
                                  <div className="ai-project-cost">
                                    Project Cost
                                  </div>
                                  <p className="ai-project-cost-p">
                                    {parseFloat(projectCost) !== 0
                                      ? `₹ ${projectCost} Cr.`
                                      : "N/A"}
                                  </p>
                                </div>

                                <div className="project-created-date">
                                  <span
                                    className={`project-created-by
                                                                    ${
                                                                      createdBy &&
                                                                      createdBy.verified
                                                                        ? "verified-user-1"
                                                                        : ""
                                                                    }
                                                                    `}
                                  />
                                  <span className="first-pp-name">
                                    <RedirectUser
                                      title={get(createdBy, "name", null)}
                                      id={get(createdBy, "id", null)}
                                      isProjectProponentDetail={true}
                                      data-test="first-pp-name"
                                    />
                                  </span>
                                  {projectPPList && projectPPList.length > 1 ? (
                                    <div
                                      className={`dropdown field-sort ${
                                        showOtherPPList ? "visible" : ""
                                      }`}
                                      onClick={this.toggleOtherPPList}
                                    >
                                      <div
                                        className={`dropdown-overlay ${
                                          showOtherPPList ? "visible" : ""
                                        }`}
                                      />
                                      <div className="dropdown-selected-value">
                                        + {projectPPList.length - 1}
                                      </div>
                                      <div className="dropdown-option-list hidden-mobile">
                                        <div className="dropdown-option-list-heading" />
                                        {projectPPList
                                          ? projectPPList.map(
                                              (value, index) => {
                                                if (index !== 0) {
                                                  return (
                                                    <RedirectUser
                                                      title={get(
                                                        value,
                                                        "name",
                                                        null
                                                      )}
                                                      id={get(
                                                        value,
                                                        "id",
                                                        null
                                                      )}
                                                      isProjectProponentDetail={
                                                        true
                                                      }
                                                    />
                                                  );
                                                }
                                              }
                                            )
                                          : null}
                                      </div>
                                    </div>
                                  ) : null}
                                  <span
                                    className="project-created-on"
                                    style={{ color: "#525252" }}
                                  >
                                    {get(project, "verificationDate")
                                      ? `Verified on: ${dateFormat(
                                          get(project, "verificationDate", null)
                                        )}`
                                      : `${
                                          isIIGDraft
                                            ? "Imported on: "
                                            : "Created on: "
                                        }
                                                                        ${dateFormat(
                                                                          get(
                                                                            project,
                                                                            "createdDate",
                                                                            null
                                                                          )
                                                                        )}`}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </>
            )}
          </>
        );

      case "Meeting Directions":
        return (
          <>
            {meetingDirections && meetingDirections.length == 0 ? (
              <div className="nodataFound-container">
                <Image src="https://pmiic-local-files.s3.ap-south-1.amazonaws.com/no_data_found.png" />
                <h3 className={`no-data-found`}>No Data Found</h3>
              </div>
            ) : (
              <div className="meeting-table-wrapper">
                <table className="meeting-table">
                  <thead>
                    <tr>
                      <th>
                        <Image src={issue_update_icon1} /> Meeting Date
                      </th>
                      <th>
                        <Image src={issue_update_icon2} /> Chaired By
                      </th>
                      <th>
                        <Image src={issue_update_icon3} /> Action Items
                      </th>
                      <th>
                        <Image src={issue_update_icon4} />
                        Tentative Resolution Date
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {meetingDirections &&
                      meetingDirections.map((item, index) => (
                        <tr key={index}>
                          <td>{this.formatDate(item.meetingDate)}</td>
                          <td>{item.meetingChairedBy}</td>
                          <td>{item.actionItem}</td>
                          <td>
                            {this.formatDate(item.tentativeResolutionDate)}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        );

      case "Recommended Action Items":
        return (
          <>
            {projectRecommendation && projectRecommendation.length == 0 ? (
              <div className="nodataFound-container">
                <Image src="https://pmiic-local-files.s3.ap-south-1.amazonaws.com/no_data_found.png" />
                <h3 className={`no-data-found`}>No Data Found</h3>
              </div>
            ) : (
              <>
                <div className="recommendation-table-wrapper">
                  <table className="recommendation-table">
                    <thead>
                      <tr>
                        <th>
                          <Image
                            src={action}
                            style={{ height: "15px", paddingRight: "3px" }}
                          />{" "}
                          Recommendation Action
                        </th>
                        <th>
                          <Image
                            src={rationale}
                            style={{ height: "15px", paddingRight: "3px" }}
                          />{" "}
                          Rationale
                        </th>
                        <th>
                          <Image
                            src={auth}
                            style={{ height: "15px", paddingRight: "3px" }}
                          />{" "}
                          Responsible Authority
                        </th>
                        <th>
                          <Image
                            src={prior}
                            style={{ height: "15px", paddingRight: "3px" }}
                          />{" "}
                          Priority
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {projectRecommendation &&
                        projectRecommendation.map((item, index) => (
                          <tr key={item.id}>
                            <td>{item.action}</td>
                            <td>{item.rationale}</td>
                            <td className="authority">
                              {item.responsibleParty}
                            </td>
                            <td>
                              <span
                                className={this.getPriorityClass(item.priority)}
                              >
                                {capitalize(item.priority)}
                              </span>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
                <div style={{ marginTop: 30 }}>
                  <Image src={Separator_AI} />
                </div>
                <div
                  className="ai-questions-container"
                  style={{
                    display:
                      projectRecommendationQuestions &&
                      projectRecommendationQuestions.length == 0
                        ? "none"
                        : null
                  }}
                >
                  {/* Header */}
                  <div className="ai-questions-header">
                    <div className="ai-icon">
                      <Image src={AI_Question_Icon} />
                    </div>
                    <h2>AI-Generated Questions for Next Meeting</h2>
                  </div>

                  {/* Questions */}
                  <div className="ai-questions-list">
                    {projectRecommendationQuestions &&
                    projectRecommendationQuestions.length > 0
                      ? projectRecommendationQuestions.map((q, index) => (
                          <div className="ai-question-card" key={q.id || index}>
                            <div className="ai-question-badge">{`Q${index +
                              1}`}</div>
                            <p className="ai-question-text">
                              {q.question || "N/A"}
                            </p>
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              </>
            )}
          </>
        );

      default:
        return null;
    }
  };

  render() {
    const { activeTab, isLoaderActive } = this.state;
    const { isOpen, projectData } = this.props;
    const tabs = [
      {
        key: "AI Summary",
        label: "AI Summary",
        defaultIcon: (
          <Image src={AI_smmary_GreyIcon} style={{ marginBottom: -4 }} />
        ),
        activeIcon: (
          <Image src={AI_Summary_White_icon} style={{ marginBottom: -4 }} />
        )
      },
      {
        key: "Similar Projects",
        label: "Similar Projects",
        defaultIcon: <Image src={Similar_Issue_grey_icon} />,
        activeIcon: <Image src={similar_issue_white_icon} />
      },
      {
        key: "Meeting Directions",
        label: "Meeting Directions",
        defaultIcon: <Image src={Issue_Update_Grey_Icon} />,
        activeIcon: <Image src={Issue_Update_white_Icon} />
      },
      {
        key: "Recommended Action Items",
        label: "Recommended Action Items",
        defaultIcon: <Image src={Recom_action_grey} />,
        activeIcon: <Image src={Recom_Action_white_icon} />
      }
    ];

    return (
      <>
        {isLoaderActive && <AILoader loading={isLoaderActive} />}

        {isOpen && !isLoaderActive && (
          <Modal
            show={isOpen}
            onHide={this.onClose}
            dialogClassName="ai-summary-modal"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                <div class="ai-header-wrapper">
                  <div class="ai-header-content">
                    <Image src={StarIcon} alt="Time" />
                    <div class="ai-text">
                      <div class="ai-title">AI Insights</div>
                      <div class="ai-subtitle">
                        Analysis for Project #{projectData.displayId}
                      </div>
                    </div>
                  </div>
                  <div class="ai-powered-by">
                    <span class="powered-text" style={{ color: "black" }}>
                      POWERED BY
                    </span>
                    <Image src={IndiaAI_Logo} class="ai-logo" />
                  </div>
                </div>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body className="p-0">
              <div className="ai-container">
                {/* Tabs */}
                <div className="ai-tabs">
                  <div
                    className="tab-slider"
                    style={{
                      width: `${100 / tabs.length}%`,
                      transform: `translateX(${tabs.findIndex(
                        t => t.key === activeTab
                      ) * 100}%)`,
                      marginLeft:
                        tabs.findIndex(t => t.key === activeTab) === 0
                          ? "12px"
                          : tabs.findIndex(t => t.key === activeTab) ===
                            tabs.length - 1
                          ? "-10px"
                          : "0px"
                    }}
                  />

                  {tabs.map(tab => (
                    <div
                      key={tab.key}
                      className={`tab ${activeTab === tab.key ? "active" : ""}`}
                      onClick={() => this.handleTabChange(tab.key)}
                      style={{ margin: "auto" }}
                    >
                      <span className="tab-icon">
                        {activeTab === tab.key
                          ? tab.activeIcon
                          : tab.defaultIcon}
                      </span>
                      <span
                        className="tab-label"
                        style={{
                          marginLeft: tab.key == "AI Summary" ? -4 : null
                        }}
                      >
                        {tab.label}
                      </span>
                    </div>
                  ))}
                </div>

                {/* Content Card */}
                <div className="content-card">
                  {this.renderTabContent()}

                  <div className="ai_disclaimer_div">
                    <Image src={ai_disclaimer} />{" "}
                    <span className="ai_disclaimer_text">Disclaimer:</span>{" "}
                    <span style={{ verticalAlign: "text-top" }}>
                      The responses are AI-generated and may not be fully
                      accurate; please verify with official PMG records.
                    </span>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        )}
      </>
    );
  }
}
